<template>
  <div class="common-pagination">
    <el-pagination
      :current-page.sync="skipNum"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    skip: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    skipNum: {
      get() {
        return 1
      },
      set(val) {
        let count = 0
        count = val === 1 ? count = 0 : count = (val - 1) * this.limit
        this.$emit('update:skip', count)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('update:skip', 0)
      this.$emit('pagination', { skip: this.skipNum, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      let count = 0
      count = val === 1 ? count = 0 : count = (val - 1) * this.limit
      this.$emit('pagination', { skip: count, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }

  }
}
</script>
<style lang="scss" scoped>
.common-pagination{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination/index.vue